module.exports = __webpack_public_path__ + "img/sm-橫式-想吃甜點是不需要理由的.211312f2.svg";